import { BasePortal, MainLoading } from '@ice-web-app/shared-ui';
import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { routes, toRelativePath } from './routes';

const HubV2 = lazy(() => import('../pages/hub-v2'));
const IntroV2 = lazy(() => import('../pages/intro-v2'));
const SourceMaterialV2 = lazy(() => import('../pages/source-material-v2'));
const DocumentV2 = lazy(() => import('../pages/document-v2'));
const ReviewV2 = lazy(() => import('../pages/review-v2'));
const SliderV2 = lazy(() => import('../pages/sidebar-v2'));
const DesignV2 = lazy(() => import('../pages/design-v2'));
const AgentPage = lazy(() => import('../pages/agent'));

export function ZoneRoutes() {
  return (
    <Routes>
      <Route path="*" element={<Navigate to={routes.notFound} />} />
      <Route path={toRelativePath(routes.base)} element={<Navigate to={routes.hub} />} />

      <Route
        element={<BasePortal sidebar microSystem showUserRole miniSidebar={true} navbar={true} sidebarHeader={true} />}
      >
        <Route
          path={toRelativePath(routes.hub)}
          element={
            <Suspense fallback={<MainLoading />}>
              <HubV2 />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.instruction)}
          element={
            <Suspense fallback={<MainLoading />}>
              <div>Instruction</div>
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.prompt)}
          element={
            <Suspense fallback={<MainLoading />}>
              <div>PromptManager</div>
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.chatbot)}
          element={
            <Suspense fallback={<MainLoading />}>
              <div>Chatbot</div>
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.introPath)}
          element={
            <Suspense fallback={<MainLoading />}>
              <IntroV2 />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.designPreviewPath)}
          element={
            <Suspense fallback={<MainLoading />}>
              <DesignV2 />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.entitySourceMaterialPath)}
          element={
            <Suspense fallback={<MainLoading />}>
              <SourceMaterialV2 />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.entityDocumentPath)}
          element={
            <Suspense fallback={<MainLoading />}>
              <DocumentV2 />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.entityFeaturePath)}
          element={
            <Suspense fallback={<MainLoading />}>
              <div>EntityFeature</div>
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.entityReviewPath)}
          element={
            <Suspense fallback={<MainLoading />}>
              <ReviewV2 />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.entitySliderPath)}
          element={
            <Suspense fallback={<MainLoading />}>
              <SliderV2 />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.agent)}
          element={
            <Suspense fallback={<MainLoading />}>
              <AgentPage />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
}
